/* =============================================
   Swiscode - Theme JavaScript
   dtrdistro.co.uk/
   ============================================= */

const ACCOUNT_LOGIN_URL = window.routes?.account_login_url || '/account/login';

document.addEventListener('DOMContentLoaded', () => {

  // ── Slideshow ──────────────────────────────
  const slideshows = document.querySelectorAll('[data-slideshow]');
  slideshows.forEach(initSlideshow);

  function initSlideshow(el) {
    const slides  = el.querySelectorAll('.slide');
    const dots    = el.querySelectorAll('.slideshow-dot');
    const prevBtn = el.querySelector('.slideshow-prev');
    const nextBtn = el.querySelector('.slideshow-next');
    let current   = 0;
    let timer     = null;
    const delay   = parseInt(el.dataset.delay || 5000);

    if (!slides.length) return;

    function show(index) {
      // hide current
      slides[current].classList.remove('active');
      if (dots[current]) {
        dots[current].classList.remove('active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      // advance
      current = (index + slides.length) % slides.length;

      // show new
      slides[current].classList.add('active');
      if (dots[current]) {
        dots[current].classList.add('active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function autoPlay() {
      clearInterval(timer);
      timer = setInterval(() => show(current + 1), delay);
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { show(current - 1); autoPlay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { show(current + 1); autoPlay(); });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { show(i); autoPlay(); });
    });

    // Keyboard navigation
    el.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { show(current - 1); autoPlay(); }
      if (e.key === 'ArrowRight') { show(current + 1); autoPlay(); }
    });

    // Pause on hover/focus
    el.addEventListener('mouseenter', () => clearInterval(timer));
    el.addEventListener('mouseleave', autoPlay);
    el.addEventListener('focusin', () => clearInterval(timer));
    el.addEventListener('focusout', autoPlay);

    // Touch support
    let touchStartX = 0;
    el.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) show(current + 1);
        else show(current - 1);
        autoPlay();
      }
    }, { passive: true });

    autoPlay();
  }

  // ── Cart Drawer ────────────────────────────
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartOpeners = document.querySelectorAll('[data-cart-open]');
  const cartClose   = document.querySelector('[data-cart-close]');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    cartDrawer?.querySelector('[data-cart-close]')?.focus();
  }

  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartOpeners.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));

  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // Close cart on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawer?.classList.contains('open')) {
      closeCart();
    }
  });

  // ── Mobile Nav ────────────────────────────
  const mobileToggle  = document.querySelector('.mobile-menu-toggle');
  const mobileMenu    = document.getElementById('mobile-menu');
  const mobileCloses  = document.querySelectorAll('.mobile-menu-close');

  function openMobileMenu() {
    mobileMenu?.removeAttribute('hidden');
    mobileMenu?.removeAttribute('aria-hidden');
    mobileToggle?.setAttribute('aria-expanded', 'true');
    mobileToggle?.classList.add('is-open');     // CSS handles hamburger ↔ close icon swap
    document.body.style.overflow = 'hidden';
    closeMobileSearch();                        // close search row if open
  }

  function closeMobileMenu() {
    mobileMenu?.setAttribute('hidden', '');
    mobileMenu?.setAttribute('aria-hidden', 'true');
    mobileToggle?.setAttribute('aria-expanded', 'false');
    mobileToggle?.classList.remove('is-open');  // CSS handles hamburger ↔ close icon swap
    document.body.style.overflow = '';
  }

  // Delegation — works even if querySelector returns null
  document.addEventListener('click', (e) => {
    if (e.target.closest('.mobile-menu-toggle')) {
      mobileMenu?.hasAttribute('hidden') ? openMobileMenu() : closeMobileMenu();
    } else if (e.target.closest('.mobile-menu-close')) {
      closeMobileMenu();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !mobileMenu?.hasAttribute('hidden')) {
      closeMobileMenu();
      mobileToggle?.focus();
    }
  });

  // ── Mobile Search Toggle ───────────────────
  const mobileSearchToggle = document.getElementById('mobile-search-toggle');
  const mobileSearchRow    = document.getElementById('mobile-search');
  const mobileSearchInput  = document.getElementById('mobile-search-input');

  function openMobileSearch() {
    mobileSearchRow?.classList.add('search-open');
    mobileSearchToggle?.setAttribute('aria-expanded', 'true');
    mobileSearchRow?.removeAttribute('aria-hidden');
    mobileSearchInput?.focus();
    if (!mobileMenu?.hasAttribute('hidden')) closeMobileMenu(); // close drawer if open
  }

  function closeMobileSearch() {
    mobileSearchRow?.classList.remove('search-open');
    mobileSearchToggle?.setAttribute('aria-expanded', 'false');
    mobileSearchRow?.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('#mobile-search-toggle')) {
      mobileSearchRow?.classList.contains('search-open') ? closeMobileSearch() : openMobileSearch();
    }
  });

  // The product gallery owns its own slider + thumbnail wiring (see
  // sections/main-product.liquid). It reacts to the `variant:change` event
  // dispatched below rather than being driven from here.

  // ── Product Variant Selection ────────────
  (function() {
    const form   = document.getElementById('product-form');
    const dataEl = document.getElementById('variant-data');
    const select = document.getElementById('variant-select');
    if (!form || !dataEl || !select) return;   // single-variant product → nothing to wire

    let variants = [];
    try { variants = JSON.parse(dataEl.textContent) || []; } catch (_) { return; }

    const priceEl   = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare]');
    const discountBadges = document.querySelectorAll('[data-discount-badge], [data-discount-badge-inline]');
    const discountChip = document.querySelector('[data-discount-chip]');
    const discountSave = document.querySelector('[data-discount-save]');
    const discountAmount = document.querySelector('[data-discount-amount]');
    const discountPct = document.querySelector('[data-discount-pct]');
    const atcBtn    = form.querySelector('[data-atc]');
    const atcText   = atcBtn ? atcBtn.querySelector('[data-atc-text]') : null;
    const selected  = [];
    const pricingEl = document.querySelector('[data-product-pricing]');
    const approved  = !!(pricingEl && pricingEl.hasAttribute('data-customer-approved'));
    // Product-wide highest compare-at price, used when the picked variant has
    // none of its own — keeps the badge in step with what Liquid rendered.
    const compareMax = pricingEl ? parseInt(pricingEl.dataset.productCompareMax, 10) || 0 : 0;

    // Seed from the initially-active buttons (rendered by Liquid)
    form.querySelectorAll('.variant-btn.border-neutral-900').forEach(btn => {
      selected[parseInt(btn.dataset.option) - 1] = btn.dataset.value;
    });

    form.addEventListener('click', (e) => {
      const btn = e.target.closest('.variant-btn');
      if (!btn || !form.contains(btn)) return;
      const group = btn.dataset.option;

      form.querySelectorAll('.variant-btn[data-option="' + group + '"]').forEach(b => {
        b.classList.remove('bg-neutral-900', 'text-white', 'border-neutral-900');
        b.classList.add('bg-white', 'text-neutral-900', 'border-gray-200');
      });
      btn.classList.add('bg-neutral-900', 'text-white', 'border-neutral-900');
      btn.classList.remove('bg-white', 'text-neutral-900', 'border-gray-200');

      selected[parseInt(group) - 1] = btn.dataset.value;
      const label = form.querySelector('.selected-option-' + group);
      if (label) label.textContent = btn.dataset.value;

      _syncVariant();
    });

    function _syncVariant() {
      let match = variants.find(v => {
        const opts = v.options || [v.option1, v.option2, v.option3].slice(0, selected.length);
        return opts.every((val, i) => val === selected[i]);
      });

      // Nothing seeded yet (first run before any click) — fall back to whatever
      // Liquid marked selected, so the badge/price still get resolved.
      if (!match && selected.filter(Boolean).length === 0) {
        match = variants.find(v => String(v.id) === String(select.value));
      }

      if (!match) {
        if (atcBtn)  atcBtn.disabled = true;
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }

      select.value = match.id;

      if (priceEl) priceEl.textContent = _fmtMoney(match.price);

      let compareAt = match.compare_at_price || 0;
      if (compareAt <= match.price) compareAt = compareMax;
      if (compareAt <= match.price) compareAt = 0;

      const onSale = approved && compareAt > match.price;
      let pct = 0;
      let saveAmt = 0;
      if (onSale) {
        saveAmt = compareAt - match.price;
        pct = Math.max(1, Math.round((saveAmt * 100) / compareAt));
      }

      if (compareEl) {
        if (onSale) {
          compareEl.textContent = _fmtMoney(compareAt);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      discountBadges.forEach(function (badge) {
        if (onSale) {
          badge.textContent = '-' + pct + '% OFF';
          badge.style.display = badge.hasAttribute('data-discount-badge') ? 'inline-block' : 'inline-flex';
        } else {
          badge.style.display = 'none';
        }
      });

      if (discountChip) {
        if (onSale) {
          discountChip.textContent = '-' + pct + '%';
          discountChip.style.display = 'inline-flex';
        } else {
          discountChip.style.display = 'none';
        }
      }

      if (discountSave) {
        discountSave.style.display = onSale ? 'block' : 'none';
        if (onSale) {
          if (discountAmount) discountAmount.textContent = _fmtMoney(saveAmt);
          if (discountPct) discountPct.textContent = String(pct);
        }
      }

      if (atcBtn) {
        atcBtn.disabled = !match.available;
        if (atcText) atcText.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }

      // Let the gallery (and anything else) react to the resolved variant.
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: match } }));
    }

    _syncVariant();   // resolve the initial selection
  })();

  // ── Quantity Buttons (delegation + AJAX cart update) ──
  document.addEventListener('click', (e) => {
    const plus  = e.target.closest('[data-plus]');
    const minus = e.target.closest('[data-minus]');
    if (!plus && !minus) return;

    const wrap  = (plus || minus).closest('.product-quantity');
    const input = wrap?.querySelector('input');
    if (!input) return;

    const min    = parseInt(input.min  ?? 0);
    const max    = parseInt(input.max  ?? 9999);
    let   newVal = parseInt(input.value);
    if (plus)  newVal = Math.min(newVal + 1, max);
    if (minus) newVal = Math.max(newVal - 1, min);
    input.value = newVal;

    // AJAX update: find line number from closest [data-cart-line]
    const row  = wrap.closest('[data-cart-line]');
    const line = row ? parseInt(row.dataset.cartLine) : null;
    if (line) _ajaxCartLine(line, newVal, row);
  });

  // ── Cart line remove (AJAX, with link fallback) ──
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    const row = rm.closest('[data-cart-line]');
    if (!row) return;                 // no JS hook → let the <a> navigate (no-JS fallback)
    e.preventDefault();
    const line = parseInt(row.dataset.cartLine);
    if (line) _ajaxCartLine(line, 0, row);
  });

  async function _ajaxCartLine(line, qty, rowEl) {
    try {
      const res  = await fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ line, quantity: qty })
      });
      if (!res.ok) return;
      const cart = await res.json();
      updateCartCount();

      if (qty === 0 && rowEl) {
        // Remove the row, then renumber remaining lines so later edits hit the right item
        rowEl.remove();
        _reindexCartLines();
      } else if (rowEl) {
        const item        = cart.items[line - 1];
        const linePriceEl = rowEl.querySelector('[data-line-price]');
        if (item && linePriceEl) linePriceEl.textContent = _fmtMoney(item.final_line_price);
      }

      // Sync money + item counts everywhere on the page (summary, hero badge, header)
      document.querySelectorAll('[data-cart-subtotal]').forEach(el => { el.textContent = _fmtMoney(cart.total_price); });
      document.querySelectorAll('[data-cart-total]').forEach(el => { el.textContent = _fmtMoney(cart.total_price); });
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });

      // Cart emptied → reload so the proper empty state renders
      if (cart.item_count === 0) window.location.reload();
    } catch (_) {}
  }

  function _reindexCartLines() {
    document.querySelectorAll('[data-cart-line]').forEach((row, i) => {
      row.setAttribute('data-cart-line', i + 1);
    });
  }

  function _fmtMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  // ── Newsletter Form ───────────────────────
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn  = form.querySelector('button[type=submit]');
      const orig = btn.textContent;
      btn.textContent = 'Subscribing...';
      btn.disabled = true;
      await new Promise(r => setTimeout(r, 1000));
      btn.textContent = 'Subscribed!';
      form.reset();
      setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 3000);
    });
  });

  // ── Sticky Header Shrink + Shadow ─────────
  const siteHeader = document.querySelector('.site-header');
  const handleScroll = () => {
    if (!siteHeader) return;
    if (window.scrollY > 60) {
      siteHeader.classList.add('is-scrolled');
    } else {
      siteHeader.classList.remove('is-scrolled');
    }
  };
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  // ── Scroll Reveal System ──────────────────
  if ('IntersectionObserver' in window) {

    // Auto-reveal section titles with underline animation
    document.querySelectorAll('.section-title').forEach(el => {
      el.classList.add('reveal');
    });

    // Stagger children of [data-reveal-grid]
    document.querySelectorAll('[data-reveal-grid]').forEach(grid => {
      Array.from(grid.children).forEach((child, i) => {
        child.classList.add('reveal-scale');
        // Stagger resets every 6 items (one visual row)
        child.style.transitionDelay = `${(i % 6) * 70}ms`;
      });
    });

    // Observe all reveal elements
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -48px 0px' });

    document.querySelectorAll('.reveal, .reveal-left, .reveal-scale').forEach(el => {
      revealObserver.observe(el);
    });

    // Benefit icons — floating effect
    document.querySelectorAll('.benefit-icon').forEach(icon => {
      revealObserver.observe(icon);
    });
  }

  // ── Add to Cart (AJAX) ────────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      const form = btn.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      if (btn.disabled) return;

      // Update only the text label if present, so the cart icon is preserved
      const label = btn.querySelector('[data-atc-text]') || btn;
      const orig  = label.textContent;
      label.textContent = 'Adding...';
      btn.disabled = true;

      const data = new FormData(form);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        });

        if (res.ok) {
          await updateCartCount();
          label.textContent = 'Added!';
          openCart();
        } else {
          const err = await res.json();
          label.textContent = err.description || 'Error';
        }
      } catch {
        label.textContent = 'Error';
      }

      setTimeout(() => {
        label.textContent = orig;
        btn.disabled = false;
      }, 2500);
    });
  });

  // ── Update Cart Count ─────────────────────
  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (err) {
      // Silently fail
    }
  }

  updateCartCount();

  // ── Collections Mega Menu ──────────────────
  (function() {
    const megaWrap   = document.getElementById('mega-wrap');
    const megaBtn    = document.getElementById('mega-btn');
    const megaPanel  = document.getElementById('mega-panel');
    const megaCol1   = document.getElementById('mega-col1');
    const megaCol2   = document.getElementById('mega-col2');
    const megaCol3   = document.getElementById('mega-col3');

    if (!megaWrap || !megaBtn || !megaPanel) return;

    let closeTimer = null;
    let activeHandle = null;

    function openMega() {
      clearTimeout(closeTimer);
      megaPanel.classList.add('is-open');
      megaPanel.setAttribute('aria-hidden', 'false');
      megaBtn.setAttribute('aria-expanded', 'true');
      megaWrap.classList.add('is-panel-open');
    }
    function closeMega() {
      megaPanel.classList.remove('is-open');
      megaPanel.setAttribute('aria-hidden', 'true');
      megaBtn.setAttribute('aria-expanded', 'false');
      megaWrap.classList.remove('is-panel-open');
      activeHandle = null;
    }
    function schedClose() { closeTimer = setTimeout(closeMega, 200); }

    megaWrap.addEventListener('mouseenter',  openMega);
    megaWrap.addEventListener('mouseleave',  schedClose);
    megaPanel.addEventListener('mouseenter', function() { clearTimeout(closeTimer); });
    megaPanel.addEventListener('mouseleave', schedClose);

    // ── Col 1 hover — show sub-collections (or products) in col 2 ──
    if (megaCol1) {
      megaCol1.addEventListener('mouseover', function(e) {
        var item = e.target.closest('.mega-item');
        if (!item || !megaCol1.contains(item)) return;
        var handle = item.dataset.handle;
        if (handle === activeHandle) return;
        activeHandle = handle;
        megaCol1.querySelectorAll('.mega-item').forEach(function(i) { i.classList.remove('is-active'); });
        item.classList.add('is-active');

        var title = item.querySelector('span').textContent.trim();
        var url   = item.getAttribute('href');
        var subs  = _subsFor(handle);
        if (subs.length) {
          renderCol2Subs(subs, url, title);
        } else {
          // Collection has no sub-collections → show its products as a text submenu
          megaCol3.innerHTML = '';
          megaCol2.innerHTML = '<div class="mega-loading">Loading…</div>';
          _fetchProducts(handle, 30, function(prods) {
            if (activeHandle !== handle) return; // moved on while loading
            megaCol2.innerHTML = _productListHTML(prods, title, url);
          });
        }
      });
    }

    function renderCol2Subs(subs, parentUrl, parentTitle) {
      megaCol3.innerHTML = '';
      megaCol2.innerHTML = subs.map(function(s, i) {
        return '<a href="' + s.url + '" class="mega-item mega-sub-item" data-sidx="' + i + '">' +
          '<span>' + _esc(s.title) + '</span>' + _arrowSvg + '</a>';
      }).join('') +
      '<a href="' + parentUrl + '" class="mega-item mega-item--all"><span>View All ' + _esc(parentTitle) + ' →</span></a>';
      megaCol2._subs = subs;

      // Auto-open the first sub-collection
      var first = megaCol2.querySelector('.mega-sub-item');
      if (first) { first.classList.add('is-active'); openSubInCol3(subs[0]); }
    }

    // ── Col 2 hover — show sub-sub-collections (or products) in col 3 ──
    if (megaCol2) {
      megaCol2.addEventListener('mouseover', function(e) {
        var item = e.target.closest('.mega-sub-item');
        if (!item || !megaCol2.contains(item)) return;
        megaCol2.querySelectorAll('.mega-item').forEach(function(i) { i.classList.remove('is-active'); });
        item.classList.add('is-active');
        openSubInCol3((megaCol2._subs || [])[item.dataset.sidx]);
      });
    }

    function openSubInCol3(s) {
      if (!s) { megaCol3.innerHTML = ''; return; }
      if (s.subs && s.subs.length) {
        megaCol3.innerHTML = '<div class="mega-col3-header"><span class="mega-col3-title">' + _esc(s.title) +
          '</span><a href="' + s.url + '" class="mega-view-all-link">View All →</a></div>' +
          '<div class="mega-col3-links">' + s.subs.map(function(g) {
            return '<a href="' + g.url + '" class="mega-col3-link">' + _esc(g.title) + '</a>';
          }).join('') + '</div>';
      } else {
        // Sub-collection has no children → show its products as a text submenu
        var reqHandle = s.handle;
        megaCol3.innerHTML = '<div class="mega-loading">Loading…</div>';
        _fetchProducts(reqHandle, 30, function(prods) {
          megaCol3.innerHTML = _productListHTML(prods, s.title, s.url);
        });
      }
    }

    function _productListHTML(prods, title, url) {
      var header = '<div class="mega-col3-header"><span class="mega-col3-title">' + _esc(title) +
        '</span><a href="' + url + '" class="mega-view-all-link">View All →</a></div>';
      if (!prods || !prods.length) return header + '<p class="mega-empty">No products found</p>';
      return header + '<div class="mega-prod-list">' + prods.map(function(p) {
        return '<a href="/products/' + p.handle + '" class="mega-prod-link">' +
          '<span class="mega-prod-name">' + _esc(p.title) + '</span>' +
          _priceCell(p, 'mega-prod-price', 'mega-prod-login') + '</a>';
      }).join('') + '</div>';
    }

    // ── Mobile Collections Panel ──
    var mobBtn    = document.getElementById('mega-mob-btn');
    var mobPanel  = document.getElementById('mega-mob-panel');
    var mobTrack  = document.getElementById('mega-mob-track');
    var mobSlide1 = document.getElementById('mega-mob-slide1');
    var mobSlide2 = document.getElementById('mega-mob-slide2');
    var mobSlide3 = document.getElementById('mega-mob-slide3');
    var mobTitle  = document.getElementById('mega-mob-title');
    var mobBack   = document.getElementById('mega-mob-back');
    var mobLevel  = 1;
    var mobHistory = [];

    function _mobGoTo(level) {
      mobLevel = level;
      if (mobTrack) mobTrack.style.transform = 'translateX(' + ((level - 1) * -33.333) + '%)';
    }

    function openMobPanel() {
      if (!mobPanel) return;
      mobPanel.removeAttribute('hidden');
      mobPanel.setAttribute('aria-hidden', 'false');
      if (mobBtn) mobBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      mobHistory = [];
      _mobGoTo(1);
      if (mobTitle) mobTitle.textContent = 'All Collections';
      if (mobBack)  mobBack.hidden = true;
    }
    function closeMobPanel() {
      if (!mobPanel) return;
      mobPanel.setAttribute('hidden', '');
      mobPanel.setAttribute('aria-hidden', 'true');
      if (mobBtn) mobBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    function mobGoBack() {
      if (!mobHistory.length) { closeMobPanel(); return; }
      var prev = mobHistory.pop();
      if (mobTitle) mobTitle.textContent = prev.title;
      _mobGoTo(prev.level);
      if (mobBack) mobBack.hidden = (prev.level <= 1);
    }

    if (mobBtn)   mobBtn.addEventListener('click', openMobPanel);
    if (mobBack)  mobBack.addEventListener('click', mobGoBack);
    document.querySelectorAll('.mega-mob-close').forEach(function(el) {
      el.addEventListener('click', closeMobPanel);
    });

    // Slide 1 tap → show sub-collections (or products) on level 2
    if (mobSlide1) {
      mobSlide1.addEventListener('click', function(e) {
        var item = e.target.closest('.mega-mob-item[data-mob-level="1"]');
        if (!item) return;
        var handle = item.dataset.handle;
        var title  = item.dataset.title;
        var url    = item.dataset.url;
        mobHistory.push({ level: 1, title: mobTitle ? mobTitle.textContent : 'All Collections' });
        if (mobTitle) mobTitle.textContent = title;
        if (mobBack)  mobBack.hidden = false;
        _mobGoTo(2);
        var subs = _subsFor(handle);
        if (subs.length) {
          mobSlide2._subs = subs;
          mobSlide2.innerHTML = _mobSubsHTML(subs, url, title);
        } else {
          mobSlide2._subs = null;
          mobSlide2.innerHTML = '<div class="mega-mob-loading">Loading…</div>';
          _fetchProducts(handle, 30, function(prods) {
            mobSlide2.innerHTML = _mobProdHTML(prods, url, title);
          });
        }
      });
    }

    // Slide 2 tap → show sub-sub-collections (or products) on level 3
    if (mobSlide2) {
      mobSlide2.addEventListener('click', function(e) {
        var item = e.target.closest('.mega-mob-item[data-mob-level="2"]');
        if (!item) return;
        var s     = (mobSlide2._subs || [])[item.dataset.sidx];
        var title = item.dataset.title;
        var url   = item.dataset.url;
        mobHistory.push({ level: 2, title: mobTitle ? mobTitle.textContent : '' });
        if (mobTitle) mobTitle.textContent = title;
        if (mobBack)  mobBack.hidden = false;
        _mobGoTo(3);
        if (s && s.subs && s.subs.length) {
          mobSlide3.innerHTML = s.subs.map(function(g) {
            return '<a href="' + g.url + '" class="mega-mob-item">' + _esc(g.title) + '</a>';
          }).join('') +
          '<a href="' + url + '" class="mega-mob-view-all">View All ' + _esc(title) + ' →</a>';
        } else {
          mobSlide3.innerHTML = '<div class="mega-mob-loading">Loading…</div>';
          _fetchProducts(s ? s.handle : '', 30, function(prods) {
            mobSlide3.innerHTML = _mobProdHTML(prods, url, title);
          });
        }
      });
    }

    function _mobSubsHTML(subs, parentUrl, parentTitle) {
      return subs.map(function(s, i) {
        return '<button class="mega-mob-item" data-sidx="' + i + '" data-url="' + s.url + '" data-title="' + _esc(s.title) + '" data-mob-level="2">' + _esc(s.title) + _mobArrow + '</button>';
      }).join('') +
      '<a href="' + parentUrl + '" class="mega-mob-view-all">View All ' + _esc(parentTitle) + ' →</a>';
    }

    function _mobProdHTML(prods, url, title) {
      if (!prods || !prods.length) {
        return '<div class="mega-mob-loading">No products found</div><a href="' + url + '" class="mega-mob-view-all">Browse ' + _esc(title) + ' →</a>';
      }
      return '<div class="mega-mob-section-header">' + _esc(title) + '</div>' +
        prods.map(function(p) {
          return '<a href="/products/' + p.handle + '" class="mega-mob-item mega-mob-prod">' +
            '<span class="mega-mob-prod-name">' + _esc(p.title) + '</span>' +
            _priceCell(p, 'mega-mob-prod-price', 'mega-mob-prod-login') + '</a>';
        }).join('') +
        '<a href="' + url + '" class="mega-mob-view-all">View All →</a>';
    }

    // ── Shared helpers ──
    var _arrowSvg = '<svg class="mega-item__arr" viewBox="0 0 6 10" fill="currentColor" width="5" height="8" aria-hidden="true"><path fill-rule="evenodd" d="M.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L4.293 5 .646 1.354a.5.5 0 0 1 0-.708" clip-rule="evenodd"/></svg>';
    var _mobArrow = '<svg class="mega-mob-item__arr" viewBox="0 0 6 10" fill="currentColor" width="5" height="8" aria-hidden="true"><path fill-rule="evenodd" d="M.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L4.293 5 .646 1.354a.5.5 0 0 1 0-.708" clip-rule="evenodd"/></svg>';

    var _cache = {};
    function _fetchProducts(handle, limit, cb) {
      if (!handle) { cb([]); return; }
      if (_cache[handle]) { cb(_cache[handle]); return; }
      fetch('/collections/' + handle + '/products.json?limit=' + limit)
        .then(function(r) { return r.json(); })
        .then(function(d) { _cache[handle] = d.products || []; cb(_cache[handle]); })
        .catch(function() { cb([]); });
    }
    var _loggedIn = window.customerLoggedIn === true;
    function _price(p) {
      var v = p.variants && p.variants[0];
      if (!v || v.price == null) return '';
      // /collections/<handle>/products.json returns price as a decimal string in major
      // units ("19.99"); the Ajax API returns integer cents (1999). Handle both.
      var num = typeof v.price === 'string' ? parseFloat(v.price) : v.price / 100;
      if (isNaN(num)) return '';
      return '£' + num.toFixed(2);
    }
    // Prices are wholesale-gated: only logged-in customers see them (matches product cards)
    function _priceCell(p, priceClass, loginClass) {
      if (!_loggedIn) return '<span class="' + loginClass + '" title="Login to view prices">Login to view</span>';
      return '<span class="' + priceClass + '">' + _price(p) + '</span>';
    }
    function _subsFor(handle) {
      var el = document.querySelector('.mega-subs-data[data-for="' + handle + '"]');
      if (!el) return [];
      try { return JSON.parse(el.textContent) || []; } catch(err) { return []; }
    }
    function _esc(s) {
      return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

  })();

});
